// Drop 002: The Statement Series. Auto-generated typographic canvas products.
export const drop002Products = [
  {
    "slug": "small-deposits-every-single-day",
    "title": "Small Deposits, Every Single Day",
    "kanji": "積",
    "drop": "002",
    "series": "Compound Series No. 09",
    "articleSlug": "abundance-affirmations-athletes",
    "metaTitle": "Small Deposits, Every Single Day Canvas Print | Ninja Athletic Club",
    "metaDescription": "Small Deposits, Every Single Day. Compound Series No. 09 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The compounding rule, framed.",
    "description": "Compound Series No. 09. Deliberately ambiguous about whether it means the bank or the barbell, because the mechanism is identical. Heavy condensed type on near-black canvas, matte black float frame.",
    "art": "/images/print-abundance-1200.webp",
    "artThumb": "/images/print-abundance-800.webp",
    "room": "/images/room-abundance-1200.webp",
    "roomThumb": "/images/room-abundance-800.webp",
    "altArt": "Black and white typographic canvas reading Small Deposits, Every Single Day, Compound Series No. 09",
    "altRoom": "Small Deposits, Every Single Day framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "be-water-then-be-stone",
    "title": "Be Water, Then Be Stone",
    "kanji": "武",
    "drop": "002",
    "series": "Martial Series No. 06",
    "articleSlug": "bruce-lee-training-philosophy",
    "metaTitle": "Be Water, Then Be Stone Canvas Print | Ninja Athletic Club",
    "metaDescription": "Be Water, Then Be Stone. Martial Series No. 06 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "Fluid about method. Immovable about standards.",
    "description": "Martial Series No. 06. The two halves only work together: adapt everything about how you train, concede nothing about whether you do. Heavy condensed type on near-black canvas.",
    "art": "/images/print-brucelee-1200.webp",
    "artThumb": "/images/print-brucelee-800.webp",
    "room": "/images/room-brucelee-1200.webp",
    "roomThumb": "/images/room-brucelee-800.webp",
    "altArt": "Black and white typographic canvas reading Be Water, Then Be Stone, Martial Series No. 06",
    "altRoom": "Be Water, Then Be Stone framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "if-it-folds-under-pressure",
    "title": "If It Folds Under Pressure",
    "kanji": "力",
    "drop": "002",
    "series": "Pressure Test No. 01",
    "articleSlug": "greatest-motivational-ideas",
    "metaTitle": "If It Folds Under Pressure Canvas Print | Ninja Athletic Club",
    "metaDescription": "If It Folds Under Pressure. Pressure Test No. 01 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The filter, not the answer.",
    "description": "Pressure Test No. 01. A test you can hang on a wall: every time you walk past, check whether what you believe is load-bearing or ornamental. Heavy condensed type on near-black canvas.",
    "art": "/images/print-motivation-1200.webp",
    "artThumb": "/images/print-motivation-800.webp",
    "room": "/images/room-motivation-1200.webp",
    "roomThumb": "/images/room-motivation-800.webp",
    "altArt": "Black and white typographic canvas reading If It Folds Under Pressure, Pressure Test No. 01",
    "altRoom": "If It Folds Under Pressure framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "motivation-is-optional",
    "title": "Motivation Is Optional. Attendance Is Not.",
    "kanji": "続",
    "drop": "002",
    "series": "Protocol No. 12",
    "articleSlug": "gym-motivation-low-days",
    "metaTitle": "Motivation Is Optional. Attendance Is Not. Canvas Print | Ninja Athletic Club",
    "metaDescription": "Motivation Is Optional. Attendance Is Not.. Protocol No. 12 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The attendance system, stated once.",
    "description": "Protocol No. 12. For the wall you see on the way out the door, which is the only place it is ever useful. Heavy condensed type on near-black canvas, matte black float frame.",
    "art": "/images/print-attendance-1200.webp",
    "artThumb": "/images/print-attendance-800.webp",
    "room": "/images/room-attendance-1200.webp",
    "roomThumb": "/images/room-attendance-800.webp",
    "altArt": "Black and white typographic canvas reading Motivation Is Optional. Attendance Is Not., Protocol No. 12",
    "altRoom": "Motivation Is Optional. Attendance Is Not. framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "build-a-room-you-cannot-skip",
    "title": "Build a Room You Cannot Skip",
    "kanji": "間",
    "drop": "002",
    "series": "Space Series No. 02",
    "articleSlug": "gym-wall-art-guide",
    "metaTitle": "Build a Room You Cannot Skip Canvas Print | Ninja Athletic Club",
    "metaDescription": "Build a Room You Cannot Skip. Space Series No. 02 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "Design the room for the version of you who doesn't want to be there.",
    "description": "Space Series No. 02. Sized for the wall opposite the door, the only sightline that is guaranteed. Heavy condensed type on near-black canvas, matte black float frame.",
    "art": "/images/print-room-1200.webp",
    "artThumb": "/images/print-room-800.webp",
    "room": "/images/room-room-1200.webp",
    "roomThumb": "/images/room-room-800.webp",
    "altArt": "Black and white typographic canvas reading Build a Room You Cannot Skip, Space Series No. 02",
    "altRoom": "Build a Room You Cannot Skip framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "the-urge-to-stop-is-data",
    "title": "The Urge to Stop Is Data",
    "kanji": "忍",
    "drop": "002",
    "series": "Mental Series No. 03",
    "articleSlug": "how-to-not-quit",
    "metaTitle": "The Urge to Stop Is Data Canvas Print | Ninja Athletic Club",
    "metaDescription": "The Urge to Stop Is Data. Mental Series No. 03 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The sentence that fits at rep seven.",
    "description": "Mental Series No. 03. The urge to stop is a reading, not a ruling, and this is the exact sentence that is useful when nothing longer will fit in your head. Near-black canvas, float frame.",
    "art": "/images/print-urge-1200.webp",
    "artThumb": "/images/print-urge-800.webp",
    "room": "/images/room-urge-1200.webp",
    "roomThumb": "/images/room-urge-800.webp",
    "altArt": "Black and white typographic canvas reading The Urge to Stop Is Data, Mental Series No. 03",
    "altRoom": "The Urge to Stop Is Data framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "hunt-like-you-eat",
    "title": "Hunt Like You Eat",
    "kanji": "獅",
    "drop": "002",
    "series": "Apex Series No. 07",
    "articleSlug": "lion-mindset-training",
    "metaTitle": "Hunt Like You Eat Canvas Print | Ninja Athletic Club",
    "metaDescription": "Hunt Like You Eat. Apex Series No. 07 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "Output has to be paid for.",
    "description": "Apex Series No. 07. The eating is the point of the hunting: effort without fuel and rest is just a slow way of getting weaker. Heavy condensed type on near-black canvas.",
    "art": "/images/print-hunt-1200.webp",
    "artThumb": "/images/print-hunt-800.webp",
    "room": "/images/room-hunt-1200.webp",
    "roomThumb": "/images/room-hunt-800.webp",
    "altArt": "Black and white typographic canvas reading Hunt Like You Eat, Apex Series No. 07",
    "altRoom": "Hunt Like You Eat framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "train-alone-arrive-together",
    "title": "Train Alone, Arrive Together",
    "kanji": "狼",
    "drop": "002",
    "series": "Pack Law No. 04",
    "articleSlug": "lone-wolf-training-pack",
    "metaTitle": "Train Alone, Arrive Together Canvas Print | Ninja Athletic Club",
    "metaDescription": "Train Alone, Arrive Together. Pack Law No. 04 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The correction to every lone wolf poster.",
    "description": "Pack Law No. 04. Solo is a phase with a purpose, not an identity. Do the work nobody sees, then go find your people. Heavy condensed type on near-black canvas, float frame.",
    "art": "/images/print-pack-1200.webp",
    "artThumb": "/images/print-pack-800.webp",
    "room": "/images/room-pack-1200.webp",
    "roomThumb": "/images/room-pack-800.webp",
    "altArt": "Black and white typographic canvas reading Train Alone, Arrive Together, Pack Law No. 04",
    "altRoom": "Train Alone, Arrive Together framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "tough-is-a-skill",
    "title": "Tough Is a Skill, Not a Gene",
    "kanji": "鍛",
    "drop": "002",
    "series": "Mental Series No. 11",
    "articleSlug": "mental-toughness-guide",
    "metaTitle": "Tough Is a Skill, Not a Gene Canvas Print | Ninja Athletic Club",
    "metaDescription": "Tough Is a Skill, Not a Gene. Mental Series No. 11 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The correction, at the exact moment you need it.",
    "description": "Mental Series No. 11. Four ordinary skills wearing one name, and none of them require a personality. For the wall you look at while deciding you don't have it. Near-black canvas.",
    "art": "/images/print-tough-1200.webp",
    "artThumb": "/images/print-tough-800.webp",
    "room": "/images/room-tough-1200.webp",
    "roomThumb": "/images/room-tough-800.webp",
    "altArt": "Black and white typographic canvas reading Tough Is a Skill, Not a Gene, Mental Series No. 11",
    "altRoom": "Tough Is a Skill, Not a Gene framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "the-hour-matters-less-than-the-order",
    "title": "The Hour Matters Less Than the Order",
    "kanji": "朝",
    "drop": "002",
    "series": "Routine Series No. 13",
    "articleSlug": "morning-routine-athletes",
    "metaTitle": "The Hour Matters Less Than the Order Canvas Print | Ninja Athletic Club",
    "metaDescription": "The Hour Matters Less Than the Order. Routine Series No. 13 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "For the argument with your alarm.",
    "description": "Routine Series No. 13. Nobody was ever made strong by a wake time. They were made strong by the four hundredth session, which happened because the routine was survivable.",
    "art": "/images/print-order-1200.webp",
    "artThumb": "/images/print-order-800.webp",
    "room": "/images/room-order-1200.webp",
    "roomThumb": "/images/room-order-800.webp",
    "altArt": "Black and white typographic canvas reading The Hour Matters Less Than the Order, Routine Series No. 13",
    "altRoom": "The Hour Matters Less Than the Order framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "one-wall-one-message",
    "title": "One Wall. One Message.",
    "kanji": "壁",
    "drop": "002",
    "series": "Space Series No. 15",
    "articleSlug": "motivational-canvas-buying-guide",
    "metaTitle": "One Wall. One Message. Canvas Print | Ninja Athletic Club",
    "metaDescription": "One Wall. One Message.. Space Series No. 15 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The whole product philosophy, printed on the product.",
    "description": "Space Series No. 15. A second statement piece in the same sightline halves the value of both. Gallery-wrapped, sized to be read from across a garage. Near-black canvas.",
    "art": "/images/print-onewall-1200.webp",
    "artThumb": "/images/print-onewall-800.webp",
    "room": "/images/room-onewall-1200.webp",
    "roomThumb": "/images/room-onewall-800.webp",
    "altArt": "Black and white typographic canvas reading One Wall. One Message., Space Series No. 15",
    "altRoom": "One Wall. One Message. framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "the-five-rings",
    "title": "Ground. Water. Fire. Wind. Void.",
    "kanji": "五",
    "drop": "002",
    "series": "Five Rings No. 05",
    "articleSlug": "musashi-five-rings-training",
    "metaTitle": "Ground. Water. Fire. Wind. Void. Canvas Print | Ninja Athletic Club",
    "metaDescription": "Ground. Water. Fire. Wind. Void.. Five Rings No. 05 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "Musashi's five books, one wall.",
    "description": "Five Rings No. 05. Ground, water, fire, wind, void: mastery constructed deliberately, in stages, by someone willing to be a beginner in public. Heavy condensed type on near-black canvas.",
    "art": "/images/print-rings-1200.webp",
    "artThumb": "/images/print-rings-800.webp",
    "room": "/images/room-rings-1200.webp",
    "roomThumb": "/images/room-rings-800.webp",
    "altArt": "Black and white typographic canvas reading Ground. Water. Fire. Wind. Void., Five Rings No. 05",
    "altRoom": "Ground. Water. Fire. Wind. Void. framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "quiet-work-loud-results",
    "title": "Quiet Work. Loud Results.",
    "kanji": "静",
    "drop": "002",
    "series": "Club Code No. 01",
    "articleSlug": "ninja-mentality-discipline-code",
    "metaTitle": "Quiet Work. Loud Results. Canvas Print | Ninja Athletic Club",
    "metaDescription": "Quiet Work. Loud Results.. Club Code No. 01 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The club code, condensed to four words.",
    "description": "Club Code No. 01. The sentence you need at 5:40 AM, and it doesn't shout at you to deliver it. Say less, log more. Heavy condensed type on near-black canvas, matte black float frame.",
    "art": "/images/print-quiet-1200.webp",
    "artThumb": "/images/print-quiet-800.webp",
    "room": "/images/room-quiet-1200.webp",
    "roomThumb": "/images/room-quiet-800.webp",
    "altArt": "Black and white typographic canvas reading Quiet Work. Loud Results., Club Code No. 01",
    "altRoom": "Quiet Work. Loud Results. framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "seven-virtues-one-standard",
    "title": "Seven Virtues. One Standard.",
    "kanji": "侍",
    "drop": "002",
    "series": "Bushido No. 07",
    "articleSlug": "samurai-bushido-athlete",
    "metaTitle": "Seven Virtues. One Standard. Canvas Print | Ninja Athletic Club",
    "metaDescription": "Seven Virtues. One Standard.. Bushido No. 07 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "Prompts, not commandments.",
    "description": "Bushido No. 07. Seven questions for the moments when you're tired, sore, and inclined to negotiate with yourself. For the wall you look at before you train, not after. Near-black canvas.",
    "art": "/images/print-virtues-1200.webp",
    "artThumb": "/images/print-virtues-800.webp",
    "room": "/images/room-virtues-1200.webp",
    "roomThumb": "/images/room-virtues-800.webp",
    "altArt": "Black and white typographic canvas reading Seven Virtues. One Standard., Bushido No. 07",
    "altRoom": "Seven Virtues. One Standard. framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "the-spartan-standard",
    "title": "The Spartan Standard",
    "kanji": "盾",
    "drop": "002",
    "series": "Warrior Series No. 08",
    "articleSlug": "spartan-warrior-mindset",
    "metaTitle": "The Spartan Standard Canvas Print | Ninja Athletic Club",
    "metaDescription": "The Spartan Standard. Warrior Series No. 08 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "Not a quote. A requirement.",
    "description": "Warrior Series No. 08. A standard is something you meet on the days you don't want to, which is the only part of the legend that was ever real. Heavy condensed type on near-black canvas.",
    "art": "/images/print-spartan-1200.webp",
    "artThumb": "/images/print-spartan-800.webp",
    "room": "/images/room-spartan-1200.webp",
    "roomThumb": "/images/room-spartan-800.webp",
    "altArt": "Black and white typographic canvas reading The Spartan Standard, Warrior Series No. 08",
    "altRoom": "The Spartan Standard framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "borrow-the-fire-build-your-own",
    "title": "Borrow the Fire, Build Your Own",
    "kanji": "声",
    "drop": "002",
    "series": "Input Series No. 10",
    "articleSlug": "speakers-worth-listening-to",
    "metaTitle": "Borrow the Fire, Build Your Own Canvas Print | Ninja Athletic Club",
    "metaDescription": "Borrow the Fire, Build Your Own. Input Series No. 10 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The correct relationship to every speech you've ever saved.",
    "description": "Input Series No. 10. Take the heat from someone else if you need it. Just don't outsource the furnace. Heavy condensed type on near-black canvas, matte black float frame.",
    "art": "/images/print-fire-1200.webp",
    "artThumb": "/images/print-fire-800.webp",
    "room": "/images/room-fire-1200.webp",
    "roomThumb": "/images/room-fire-800.webp",
    "altArt": "Black and white typographic canvas reading Borrow the Fire, Build Your Own, Input Series No. 10",
    "altRoom": "Borrow the Fire, Build Your Own framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "no-warning-just-arrival",
    "title": "No Warning. Just Arrival.",
    "kanji": "虎",
    "drop": "002",
    "series": "Apex Series No. 03",
    "articleSlug": "tiger-mindset-silent-power",
    "metaTitle": "No Warning. Just Arrival. Canvas Print | Ninja Athletic Club",
    "metaDescription": "No Warning. Just Arrival.. Apex Series No. 03 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The stalk, not the roar.",
    "description": "Apex Series No. 03. Unnoticeable for eleven months, undeniable in the twelfth. For the corner of the room where you actually train. Heavy condensed type on near-black canvas.",
    "art": "/images/print-arrival-1200.webp",
    "artThumb": "/images/print-arrival-800.webp",
    "room": "/images/room-arrival-1200.webp",
    "roomThumb": "/images/room-arrival-800.webp",
    "altArt": "Black and white typographic canvas reading No Warning. Just Arrival., Apex Series No. 03",
    "altRoom": "No Warning. Just Arrival. framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  },
  {
    "slug": "i-am-the-work-not-the-mood",
    "title": "I Am the Work, Not the Mood",
    "kanji": "言",
    "drop": "002",
    "series": "Affirmation Series No. 02",
    "articleSlug": "warrior-affirmations",
    "metaTitle": "I Am the Work, Not the Mood Canvas Print | Ninja Athletic Club",
    "metaDescription": "I Am the Work, Not the Mood. Affirmation Series No. 02 from Drop 002, the Statement Series. Museum-grade canvas in a matte black float frame. From $79.",
    "short": "The shortest true thing we could find.",
    "description": "Affirmation Series No. 02. An affirmation you cannot argue with, built to hold on the mornings when nothing else does. Heavy condensed type on near-black canvas, float frame.",
    "art": "/images/print-work-1200.webp",
    "artThumb": "/images/print-work-800.webp",
    "room": "/images/room-work-1200.webp",
    "roomThumb": "/images/room-work-800.webp",
    "altArt": "Black and white typographic canvas reading I Am the Work, Not the Mood, Affirmation Series No. 02",
    "altRoom": "I Am the Work, Not the Mood framed canvas print in a matte black float frame on a dark wall",
    "sizes": [
      {
        "label": "12 x 18",
        "price": 79
      },
      {
        "label": "18 x 27",
        "price": 119
      },
      {
        "label": "24 x 36",
        "price": 159
      }
    ]
  }
];
